import useInitHomepage from './onInitHomepage';

export const OnInitProvider = {
  useInitHomepage,
};
